export default __webpack_public_path__ + "static/media/notification-bell-red.942783d5.svg";